import themes from "themes";
import { colorPalette } from "themes/theme";

export const fade = {
  exit: { opacity: 0 },
  initial: { opacity: 0 },
  animate: { opacity: 1 },
};

export const slideRight = {
  exit: {
    opacity: 0,
    x: 40,
    y: 0,
    transition: {
      ease: "easeInOut",
    },
  },
  initial: {
    opacity: 0,
    x: 40,
    y: 0,
    transition: {
      ease: "easeInOut",
    },
  },
  animate: {
    opacity: 1,
    x: 0,
    y: 0,
    transition: {
      ease: "easeInOut",
    },
  },
};
export const transition = {
  ease: "linear",
  type: "tween",
  duration: 5,
}

export const slideUp = {
  exit: {
    opacity: 0,
    y: "-100vh",
    transition: {
      ease: "easeInOut",
    },
  },
  initial: {
    opacity: 0,
    y: "-100vh",
    x: "0",
    transition: {
      ease: "easeInOut",
    },
  },
  animate: {
    opacity: 1,
    y: "0",
    x: "0",
    transition: {
      ease: "easeInOut",
    },
  },
};

export const heroSlideUp = {
  exit: {
    opacity: 0,
    backgroundColor: "#FFF",
    y: "-30vw",
    transition: {
      ease: "easeInOut",
    },
  },
  initial: {
    opacity: 0,
    y: "-30vw",
    transition: {
      ease: "easeInOut",
    },
    backgroundColor: colorPalette.primary.main,
    height: "100vh",
  },
  animate: {
    opacity: 1,
    backgroundColor: colorPalette.primary.main,
    y: "0",
    transition: {
      ease: "easeInOut",
    },
  },
};

export const errorSlideup = (barHeight = 0) => {
  return {
    exit: {
      opacity: 0,
      backgroundColor: "#FFF",
      y: "-30vw",
      transition: {
        ease: "easeInOut",
      },
    },
    initial: {
      opacity: 0,
      y: "-30vw",
      transition: {
        ease: "easeInOut",
      },
      backgroundColor: colorPalette.secondary.main,
      height: `calc(100vh - ${barHeight}px)`,
    },
    animate: {
      opacity: 1,
      backgroundColor: colorPalette.secondary.main,
      y: "0",
      transition: {
        ease: "easeInOut",
      },
    },
  };
};
